import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
export default function Promo({ promoteSnippet }) {
    // promoteSnippet may or may not be in an array
    const data = promoteSnippet instanceof Array ? promoteSnippet[0] : promoteSnippet;
    if (!(data === null || data === void 0 ? void 0 : data.content)) {
        return null;
    }
    return (React.createElement(RawHTML, { html: data.content.description }));
}
